import { render } from '@testing-library/react';
import React, { useState, useEffect } from 'react';
import * as constants from '../../constants/constants';
import MatchQuestion from '../MatchQuestion';
import CrazyArrow from '../CrazyArrow';
import DirectionArrow from '../DirectionArrow';
import PointAndMove from '../PointAndMove';
import './Tutorial.scss';
import { getColorName } from '../../utils/utils';
import { TutorialLevels } from './constants';
import { Modal } from 'antd';

const Tutorial = (props) => {
    const currentLevel = props.currentLevel;
    const [startTime, setStartTime] = useState(null);
    const [currentQuestion, setCurrentQuestion] = useState(0);
    const questionSpecs = TutorialLevels[currentLevel][currentQuestion];
    const [highlightResponse, setHighlightResponse] = useState(null);
    const [modalSpecs,setModalSpecs] = useState(null);

    const qstyle = {
        fontSize: "30px",
        textTransform: "capitalize",
        fontStyle: "italic",
        fontWeight: "bold",
        marginTop: "10px",
        marginBottom: "10px",
    }

    const renderQuestion = (type) => {
        switch (type) {
            case constants.MATCH:
                return <span>{`Does the ${questionSpecs.specs.match} of the ${questionSpecs.specs.with} word match the color of the ${questionSpecs.specs.with == "left" ? "right" : "left"} word?`}</span>
            case constants.CRAZY_ARROWS:
                return `Does the ${questionSpecs.match} of the ${questionSpecs.with} arrow match the text? `
            case constants.TRIPLE_ARROWS:
                return `If the arrows are ${getColorName(questionSpecs.arrowColors)} tap the direction that they are ${questionSpecs.type} pointing `;
            case constants.PONT_OR_MOVE:
                return questionSpecs.specs.message || <React.Fragment>{`What direction are the arrows`}<h5 style={qstyle}>{questionSpecs.specs.type} ?</h5></React.Fragment>;
            case constants.POINTING:
                return questionSpecs.specs.message;
            default:
                return '';
        }
    }

    const renderQuestionVisual = (type) => {
        switch (type) {
            case constants.MATCH:
                return <MatchQuestion specs={questionSpecs.specs} />
            case constants.CRAZY_ARROWS:
                return <CrazyArrow specs={questionSpecs.specs} />
            case constants.TRIPLE_ARROWS:
                return <DirectionArrow specs={questionSpecs.specs} />
            case constants.POINTING:
                return <DirectionArrow specs={questionSpecs.specs} />;
            case constants.PONT_OR_MOVE:
                return <PointAndMove specs={questionSpecs.specs} />
            default:
                return '';
        }
    }

    const wasLastLevel = currentQuestion == TutorialLevels[currentLevel].length - 1

    return (
        <div className="Tutorial">
            <div className={`visual ${highlightResponse ? (highlightResponse == "correct" ? 'correct-answer' : 'wrong-answer') : ''}`}>
                {renderQuestionVisual(questionSpecs.type)}
            </div>
            <div className="question">
                {renderQuestion(questionSpecs.type)}
            </div>
            {!questionSpecs.specs?.options?.length && (
                <button className={`questionOptions`} onClick={() => setCurrentQuestion(currentQuestion + 1)}><span>Next</span></button>
            )}
            {
                questionSpecs.specs?.options.map((option, index) => (
                    <button disabled={highlightResponse} className={`questionOptions style-${index} black ${questionSpecs.type == constants.TRIPLE_ARROWS || questionSpecs.type == constants.PONT_OR_MOVE || questionSpecs.type == constants.POINTING ? 'override-all' : ''}`} onClick={(event) => {
                        if (questionSpecs.specs.answer.toString() === option.value.toString()) {
                            setHighlightResponse('correct');
                            setModalSpecs({
                                style: 4,
                                title: 'Correct Answer!',
                                message: questionSpecs.specs.correctMessage,
                            })
                        }
                        else {
                            setHighlightResponse('wrong');
                            setModalSpecs({
                                style: 1,
                                title: 'Wrong Answer!',
                                message: questionSpecs.specs.incorrectMessage,
                            })
                        }
                        // setTimeout(() => setHighlightResponse(null), 200)
                    }}>
                        <span>{option.name}</span>
                    </button>
                ))
            }
            {modalSpecs && <Modal
                isOpen={modalSpecs}
                visible={modalSpecs}
                onRequestClose={() => setModalSpecs(null)}
                overlayClassName="Overlay"
                contentLabel="Example Modal"
                className="Modal"
            >
                <h1>{modalSpecs?.title}</h1>
                <p className='mb-32'>{modalSpecs?.message}</p>
                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                   <div>
                   <button className={`questionOptions style-${modalSpecs.style}`} onClick={() => {
                        setModalSpecs(null);
                        setHighlightResponse(null);
                        if(wasLastLevel) {
                            props.onEnd();
                        }
                        else {
                            setCurrentQuestion(currentQuestion + 1);
                        }
                    }}><span>{wasLastLevel ? 'Start Game' : 'Continue'}</span></button>
                   </div>
                </div>
            </Modal>}
        </div>
    );
}

export default Tutorial;